const ServerRegions = Object.freeze({
  0: 'US',
  1: 'EU'
})

export { ServerRegions }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/mixpanel/ResidencyServerRegionsEnum.js